import { get, post } from "@/utils/request"; // 导入模块

// 筛选列表
export const getCategorizer = (params) =>
    get("Api/Job/GetCategorizer", params);

// 职位列表
export const GetJobJobList = (params) =>
    post("Api/Job/GetJobJobList", params);

// 侧栏名企招聘
export const GetCompanyList = (params) =>
    get("Api/Job/GetJobClientList", params);

// 城市列表
export const GetAreaList = (params) =>
    get("Api/Job/GetAreaList", params);





// // 筛选列表
// export const getCategorizer = (params) =>
//     get("api/Api/Job/GetCategorizer", params);

// // 职位列表
// export const GetJobJobList = (params) =>
//     post("api/Api/Job/GetJobJobList", params);

// // 侧栏名企招聘
// export const GetCompanyList = (params) =>
//     get("api/Api/Job/GetJobClientList", params);

// // 城市列表
// export const GetAreaList = (params) =>
//     get("api/Api/Job/GetAreaList", params);

